export enum LoadingDataStates {
  notStarted = 'notStarted',
  loading = 'loading',
  initializing = 'initializing',
  error = 'error',
  noAuthorizedLocations = 'noAuthorizedLocations',
  loaded = 'loaded',
}
